import { ToolHandler, ToolRegistry } from "./types";
import { MultimodalLiveClient } from "../lib/multimodal-live-client";

class ToolRegistryManager {
  private static instance: ToolRegistryManager;
  private registry: ToolRegistry;

  private constructor() {
    this.registry = new Map();
  }

  static getInstance(): ToolRegistryManager {
    if (!ToolRegistryManager.instance) {
      ToolRegistryManager.instance = new ToolRegistryManager();
    }
    return ToolRegistryManager.instance;
  }

  registerTool(toolHandler: ToolHandler): void {
    this.registry.set(toolHandler.name, toolHandler);
  }

  getTool(name: string): ToolHandler | undefined {
    return this.registry.get(name);
  }

  getAllTools(): ToolHandler[] {
    return Array.from(this.registry.values());
  }

  getToolDeclarations(): any[] {
    return Array.from(this.registry.values()).map(tool => tool.declaration);
  }

  async handleToolCall(toolCall: any, client: MultimodalLiveClient): Promise<void> {
    for (const functionCall of toolCall.functionCalls) {
      const tool = this.getTool(functionCall.name);
      if (tool) {
        // Create a toolCall with only the specific functionCall for this tool
        const specificToolCall = {
          functionCalls: [functionCall]
        };
        await tool.handleToolCall(specificToolCall, client);
      }
    }
  }
}

export default ToolRegistryManager;
